import React from 'react';
import PropTypes from 'prop-types';
import {Form} from "antd";

@autobind
/**
 *
 * @class ListWrapper
 * @extends PureComponen
 */
export default class RangeDate extends React.PureComponent {
    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        required: PropTypes.bool,
        meta: PropTypes.object,
        validateStatus: PropTypes.oneOf([
            'success', 'warning', 'error', 'validating',
        ]),
        defaultValue: PropTypes.string,
        size: PropTypes.string,
        disabled: PropTypes.bool,
        addonBefore: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        addonAfter: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        onPressEnter: PropTypes.func,
        autosize: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({
                minRows: PropTypes.number,
                maxRows: PropTypes.number,
            }),
        ]),
        input: PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
        }),
        rest: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
        ]),
    };

    static defaultProps = {
        label: undefined,
        validateStatus: undefined,
        required: false,
        input: {},
        disabled: false,
    };


    /**
     *
     */
    componentWillMount() {
        super.componentWillMount();

        const {input, defaultValue} = this.props;

        input.onChange(defaultValue);
    }


    /**
     *
     * @return {String}
     * @private
     */
    _validateStatus() {
        const {disabled, required, validateStatus, input, meta} = this.props;
        let _status = validateStatus;

        if (!disabled) {
            if (meta.asyncValidating) {
                _status = 'validating';
            } else if (meta.touched) {
                if (meta.error) {
                    _status = 'error';
                } else {
                    if (!required && app._.isEmpty(input.value)) {
                        _status = 'warning';
                    } else if (meta.valid) {
                        _status = 'success';
                    }
                }
            }
        }

        return _status;
    }

    onChange= (value)=>{
        let {input} = this.props;
        let newValue =value;
        if(input.value !== newValue){
            input.onChange(newValue);
        }
    }

    /**
     *
     * @return {XML}
     */
    render() {
        const {
            input, defaultValue, size, onPressEnter, addonBefore,
            addonAfter, disabled, label, required, validateStatus,
            meta, ...rest
        } = this.props;


        return (
            <Form.Item
                label={label}
                help={meta.touched && meta.error}
                required={required}
                validateStatus={this._validateStatus()}
                hasFeedback
            >

                <div
                    style={{
                        overflow: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent:'center',
                        flexDirection: 'row',
                    }}
                >
                    <button
                        className={"ant-btn " + (input && input.value === '1-days'? ' ant-btn-primary' : '')}
                        onClick={()=>{this.onChange('1-days')}}
                    >
                        یک روز
                    </button>

                    <button
                        className={"ant-btn " + (input && input.value === '1-weeks'? ' ant-btn-primary' : '')}
                        onClick={()=>{this.onChange('1-weeks')}}
                    >
                        یک هفته
                    </button>

                    <button
                        className={"ant-btn " + (input && input.value === '2-weeks'? ' ant-btn-primary' : '')}
                        onClick={()=>{this.onChange('2-weeks')}}
                    >
                        دو هفته
                    </button>

                    <button
                        className={"ant-btn " + (input && input.value === '1-months'? ' ant-btn-primary' : '')}
                        onClick={()=>{this.onChange('1-months')}}
                    >
                        یک ماه
                    </button>
                    <button
                        className={"ant-btn " + (input && input.value === '2-months'? ' ant-btn-primary' : '')}
                        onClick={()=>{this.onChange('2-months')}}
                    >
                        دو ماه
                    </button>


                </div>

                <button
                    className={"ant-btn "}
                    onClick={()=>{this.onChange(null)}}
                >
                    انتخاب از بازه
                </button>
            </Form.Item>
        );
    }
}
